import styled from 'styled-components'

export const ModalMainDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100vw;
  height: 100vh;
`;
export const ModalDiv = styled.div`
  min-height: 180px;
  min-width: 180px;
  position: fixed;
  z-index: 501;
  background-color: white;
  border-radius: 12px;
  box-shadow: 1px 1px 1px black;
  padding: 24px;
  top: 40%;
  box-sizing: border-box;
  transition: all 0.3s ease-out;
  font-family: sans-serif;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const ModalWrapDiv = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 500;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
export const HeadingDiv = styled.div`
  font-family: sans-serif;
  font-weight: bold;
  font-size: 16px;
  color: #000000;
  padding: 20px 0px 10px 0px;
`;
export const SubHeadingDiv = styled.div`
  font-family: sans-serif;
  font-size: 16px;
  color: #787878;
`;
export const LoaderWrapDiv = styled.div`
  height: 50px;
  width: 67px;
  position: relative;
`;
export const OutlineImg = styled.img`
  height: 100%;
  position: absolute;
  z-index: 1;
`;
export const AnimationDiv = styled.div`
  height: 100%;
  position: relative;
  -webkit-mask-image: url(/loader_mask.svg);
  mask-image: url(/loader_mask.svg);
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
`;
export const WaveImg = styled.img`
  height: 100%;
  position: absolute;
  left: 0px;
  animation: linear infinite;
  animation-name: wave;
  -webkit-animation: linear infinite;
  -webkit-animation-name: wave;
  z-index: ${props => props.zindex ? props.zindex : '3'};
  animation-duration: ${props => props.duration ? props.duration : '2s'};
  -webkit-animation-duration: ${props => props.duration ? props.duration : '2s'};
  @keyframes wave {
    0% { left: 0; }
    100% { left: -70%; }
  }
`;
export const BubbleDiv = styled.div`
  height: 7%;
  width: 5%;
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  animation: linear infinite;
  animation-name: bubble;
  -webkit-animation: linear infinite;
  -webkit-animation-name: bubble;
  animation-duration: ${props => props.duration ? props.duration : '2s'};
  -webkit-animation-duration: ${props => props.duration ? props.duration : '2s'};
  @keyframes bubble {
    0% { top: 70%; }
    100% { top: -10px; }
  }
`;
